import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { useParams } from "react-router-dom";
import HomeDetailComponent from './HomeDetailComponent';
import HomeCheckListComponent from './HomeCheckListComponent';
import StaffComponent from './StaffComponent';
import HomeAuditReportManagement from '../AuditReportManagement/HomeAuditReportManagement';
import * as apiUtility from "../../config/APIUtils";
import HomeAdminPermissions from '../AdminPermissions_Component/HomeAdminPermissions';
import HomePolicyComponent from './HomePolicyComponent';


function HomeCheckListAndPolicyComponent(props) {
    const [homes_list, setHomesList] = useState([]);

    const [user_ID, setUser_ID] = useState(-1);
    
    var propsId = props.homeIdFprAdmin
    var params = propsId;
    if (props.id) {
        params = props.id
    }

    var user_id = useParams().id;
    var propsId2 = props.userId;
    var userID = propsId2;
    if (!userID) {
        userID = user_id;
    }
   
    useEffect(async () => {
        setUser_ID(userID);
        if (props.homeIdFprAdmin) {
            params = props.homeIdFprAdmin
        }
        var orgProps;
        if (props.orgId) {
            orgProps = props.orgId
        }

        if(orgProps == undefined && params !== undefined){
            //When ORG ID is not present just search with Home ID
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/getHomeDetails/" + params;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
                // setshowSpinner(false);
            });

        }else{
            //When ORG ID is present, then search for all Home.
            const BASE_URL_GET_All_HOMELIST = "orgnization/getHomesList/" + orgProps;
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_All_HOMELIST;
            await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(res => {
                setHomesList(res.data)
            }).catch((error) => {
                console.error(error);
            });
        }

        
    }, [props.homeIdFprAdmin])

    

    return (
        <div>

            <Tabs defaultActiveKey="homeCheckListComponent" fill style={{ display: "flex", marginTop: "5%" }}>
                 <Tab eventKey="homeCheckListComponent" title="Manage Training Templates">
                    <HomeCheckListComponent id={params} />
                </Tab> 

                <Tab eventKey="homePolicyComponent" title="Manage Home Docs">
                    <HomePolicyComponent id={params} orgId={props.orgId} />
                </Tab>
               
               
            </Tabs>

        </div>
    )
}

export default HomeCheckListAndPolicyComponent